import "./App.css";
import Home from "./Pages/Home/Home";
import Team from "./Pages/TeamMembers/Team";
import Quiz from "./Pages/Quiz/Quiz";
import EditQuiz from "./Pages/Quiz/EditQuiz";
import Rank from "./Pages/Ranking/Rank";
import SingIn_Outs from "./Pages/SingIn_Out/SingIn_Out";
import Insertquiz from "./Pages/Quiz/insertquiz";
import Courses from "./Pages/Courses/Courses";

import HomeUser from "./Pages/User/HomeUsers";
import AllQuizs from "./Pages/User/AllQuizs";
import QuizUser from "./Pages/User/QuizUser";
import StartQuizs from "./Pages/User/StartQuizs";
import Ranking from "./Pages/User/Rarking";
import Login from "./Pages/User/Login";
import AboutUS from "./Pages/User/AboutUS";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeUser />,
  },
  {
    path: "/Login",
    element: <Login />,
  },
  {
    path: "/AboutUS",
    element: <AboutUS />,
  },
  {
    path: "/AllQuizs",
    element: <AllQuizs />,
  },
  {
    path: "/QuizUser",
    element: <QuizUser />,
  },
  {
    path: "/StartQuizs",
    element: <StartQuizs />,
  },
  {
    path: "/Ranking",
    element: <Ranking />,
  },
  {
    path: "/Home",
    element: <Home />,
  },
  {
    path: "/team",
    element: <Team />,
  },
  {
    path: "/Courses",
    element: <Courses />,
  },
  {
    path: "/Quiz",
    element: <Quiz />,
  },
  {
    path: "/EditQuiz",
    element: <EditQuiz />,
  },
  {
    path: "/Rank",
    element: <Rank />,
  },
  {
    path: "/SingIn_Outs",
    element: <SingIn_Outs />,
  },
  {
    path: "/Insertquiz",
    element: <Insertquiz />,
  },
]);

function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
